import sodium from "libsodium-wrappers";

let isReady = false;
async function ready() {
  if (!isReady) {
    await sodium.ready;
    isReady = true;
  }
}

// Load base64 keys from .env
const serverPublic = process.env.REACT_APP_SERVER_PUBLIC_KEY?.trim();


export async function encryptForServer(data) {
  await ready();

  const jsonStr = typeof data === "string" ? data : JSON.stringify(data);
  const msgBytes = sodium.from_string(jsonStr);
  const serverPub = sodium.from_base64(serverPublic, sodium.base64_variants.ORIGINAL);

  const cipher = sodium.crypto_box_seal(msgBytes, serverPub);
  return sodium.to_base64(cipher, sodium.base64_variants.ORIGINAL);
}

